import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supplierApi, type Supplier } from '../../api/supplier';

export function ComplianceDashboardPage() {
  const [suppliers, setSuppliers] = useState<Supplier[]>([]);

  useEffect(() => {
    void supplierApi.listSuppliers().then(setSuppliers);
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/suppliers" className="text-sm text-slate-600 hover:underline">← Supplier hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Compliance dashboard</h1>
      <ul className="mt-6 space-y-2 text-sm">
        {suppliers.map((s) => (
          <li key={s.id} className="rounded border p-3">
            {s.legal_name} — Compliance score tracked via health {s.health_score.toFixed(0)}%
          </li>
        ))}
      </ul>
    </div>
  );
}
